import apiClient from "../../config/apiClient";


export const fetchDrugMart = async (id) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.get(`/public/portal?url=inventory/drugs?overTheCounter=true%26page=1%26q=%26plusGens=`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  

//   inventory/drugs?page=1&q=&plusGens=